import {
  DisplayOrder, Hidden, Number, Options, Required, String, TableDisplayedDefault, TableIdentifier
} from "projects/nter-ui-kit/src/lib/webkit/components/crud-item/crud-item-decorator";

export enum GroupedRoleClassification {
  PRINCIPLE = 'PRINCIPLE',
  MEMBER = 'MEMBER'
}

export enum GroupedRoleElevationLevel {
  NONE = 'NONE',
  INTERNAL_ADMIN = 'INTERNAL_ADMIN'
}

export class GroupedRole {
  @DisplayOrder(1)
  @Number('ID')
  @TableIdentifier
  roleId?: number;

  @DisplayOrder(2)
  @String('Code')
  @TableDisplayedDefault
  roleCode?: string;

  @DisplayOrder(3)
  @String('Name')
  @TableDisplayedDefault
  roleName?: string;

  @DisplayOrder(4)
  @String('Description')
  @TableDisplayedDefault
  roleDescription?: string;

  @DisplayOrder(5)
  @String('Classification')
  @Options([{PRINCIPLE: 'PRINCIPLE'}, {MEMBER: 'MEMBER'}])
  classification?: GroupedRoleClassification;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.roleId = obj.roleId ?? null;
    this.roleCode = obj.roleCode ?? null;
    this.roleName = obj.roleName ?? null;
    this.roleDescription = obj.roleDescription ?? null;
    this.classification = obj.classification ?? null;
  }
}

export class GroupedPrincipleRole extends GroupedRole {
  @DisplayOrder(6)
  @String('Elevation')
  @Options([{NONE: "NONE"}, {INTERNAL_ADMIN: "INTERNAL_ADMIN"}])
  @TableDisplayedDefault
  elevationLevel?: GroupedRoleElevationLevel;

  memberRoles?: GroupedRole[];

  constructor(obj: any = {}) {
    obj = obj || {};
    super(obj);
    this.elevationLevel = obj.elevationLevel ?? null;
    this.memberRoles = obj.memberRoles ?? [];
  }
}

export class UngroupedRole extends GroupedRole {
  users?: RoleGrantedUser[] = [];

  constructor(obj: any = {}) {
    obj = obj || {};
    super(obj);
    this.users = obj.users ?? [];
  }
}

export class RoleGroupModule {
  platformSystemCode?: string;
  platformOfferingType?: string;
  moduleGroupCode?: string;
  principleRoleGroups?: GroupedPrincipleRole[];

  constructor(obj: any = {}) {
    obj = obj || {};
    this.platformSystemCode = obj.platformSystemCode ?? null;
    this.platformOfferingType = obj.platformOfferingType ?? null;
    this.moduleGroupCode = obj.moduleGroupCode ?? null;
    this.principleRoleGroups = obj.principleRoleGroups ?? [];
  }
}


export class RegisterUserRequest {
  @String('First name')
  @Required
  @DisplayOrder(1)
  public firstname?: string;

  @String('Last name')
  @Required
  @DisplayOrder(2)
  public lastname?: string;

  @String('Email')
  @Required
  @DisplayOrder(3)
  public email?: string;

  constructor(obj: any = {}) {
    this.firstname = obj.firstname ?? null;
    this.lastname = obj.lastname ?? null;
    this.email = obj.email ?? null;
  }
}

export class GrantForConsoleRequest {
    public user: RegisterUserRequest;
    public offeringUuid?: string;
    public principleId?: string;
    public roleCodes?: string[];

    constructor(obj : any = {}){
      this.user = obj.user ?? null;
      this.offeringUuid = obj.offeringUuid ?? null;
      this.principleId = obj.principleId ?? null;
      this.roleCodes = obj.roleCodes ?? [];
    }
}

export class GrantedRole {
  roleId?: number;
  roleCode?: string;
  offeringUuid?: string;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.roleId = obj.roleId ?? null;
    this.roleCode = obj.roleCode ?? null;
    this.offeringUuid = obj.offeringUuid ?? null;
  }
}

export class RoleGrantedUser {

  @String('ID')
  @DisplayOrder(1)
  @TableIdentifier
  public grantId?: number;

  @String('User ID')
  public userId?: number;

  @String('Name')
  @DisplayOrder(1)
  @TableDisplayedDefault
  public userFirstname?: string;

  @String('Last name')
  @DisplayOrder(1)
  @TableDisplayedDefault
  public userLastname?: string;

  @String('Email')
  @DisplayOrder(1)
  @TableDisplayedDefault
  public userEmail?: string;

  @String('Principle ID')
  public grantPrincipleId?: string;

  @String('Principle Type')
  public grantPrincipleType?: string;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.grantId = obj.grantId ?? null;
    this.userId = obj.userId ?? null;
    this.userFirstname = obj.userFirstname ?? null;
    this.userLastname = obj.userLastname ?? null;
    this.userEmail = obj.userEmail ?? null;
    this.grantPrincipleId = obj.grantPrincipleId ?? null;
    this.grantPrincipleType = obj.grantPrincipleType ?? null;
  }
}
